import { spLogTags } from '@eventr/common'
import {
    AutoCompleteInputFieldV2,
    Gutters,
    LoadingSpinner,
    MainButton,
    TextInputField,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../i18n/i18next'
import { Paths } from '../../routes'
import { bs, useBoundStore } from '../../state/bound.store'
import { useEphemeralStore } from '../../state/useEphemeralStore'
import { NavigationView } from '../layout/NavigationView'

export const HotelReturnPage: FC = () => {
    const {
        setReturnReservationObj,
        returnReservationObj,
        bookingLoading,
        handleAddReservation,
    } = useEphemeralStore(
        useShallow((s) => {
            return {
                setReturnReservationObj: s.setReturnReservationObj,
                returnReservationObj: s.returnReservationObj,
                bookingLoading: s.bookingLoading,
                handleAddReservation: s.handleAddReservation,
            }
        })
    )

    const { itineraryMap, selectedOrg, profile } = useBoundStore(
        useShallow((s) => {
            return {
                itineraryMap: s.itineraryMap,
                selectedOrg: s.selectedOrg,
                profile: s.profile,
            }
        })
    )

    /// URL Params for use from return.
    const urlParams = new URLSearchParams(window.location.search)

    const itinerariesOptions = itineraryMap.map((itinerary) => {
        return {
            id: itinerary.id,
            label: itinerary.itinerary_name,
        }
    })

    useEffect(() => {
        const tmpConf = urlParams.get('conf')
        const tmpEmail = urlParams.get('emailTo')

        const selectedOption = itinerariesOptions?.find((itin) => {
            return String(itin.id) === String(bs().selectedItinID)
        })

        if (tmpConf && tmpEmail) {
            setReturnReservationObj({
                email: tmpEmail,
                confirm: tmpConf,
                selectedItinerary: selectedOption,
                justReturned: true,
            })
        } else {
            setReturnReservationObj({
                selectedItinerary: selectedOption,
                email: profile.email,
                justReturned: false,
            })
        }
    }, [])

    useEffect(() => {
        if (
            returnReservationObj &&
            returnReservationObj.confirm &&
            returnReservationObj.email &&
            returnReservationObj.justReturned &&
            returnReservationObj.selectedItinerary &&
            selectedOrg &&
            selectedOrg.name
        ) {
            spLogTags('Send add reservation request on return to page', [
                'HotelBooking',
            ])
            handleAddRes()
        }
    }, [returnReservationObj, selectedOrg])

    async function handleAddRes() {
        await handleAddReservation(selectedOrg.name, async () => {
            await bs().forceItineraryMapUpdate()
            window.pushPath(Paths.home)
        })
    }

    if (!returnReservationObj) {
        return null
    }

    return (
        <NavigationView
            usePageTransition
            navigationBarTitle={i18n.t('booking.addBooking')}
            backButtonAction={async () => {
                window.goBack()
            }}
        >
            <Gutters>
                <Box>
                    {bookingLoading && <LoadingSpinner />}
                    {!bookingLoading && (
                        <Box display={'grid'} gap={'8px'}>
                            <Typography>
                                {i18n.t('booking.paraAddRes')}
                            </Typography>
                            <Box height={'8px'} />
                            <AutoCompleteInputFieldV2
                                value={returnReservationObj.selectedItinerary}
                                fieldLabel={i18n.t('account.itineraries')}
                                options={itinerariesOptions}
                                onChange={(item) => {
                                    if (item && item.id) {
                                        setReturnReservationObj({
                                            ...returnReservationObj,
                                            selectedItinerary: {
                                                id: Number(item.id),
                                                label: item.label,
                                            },
                                            justReturned: false,
                                        })
                                    }
                                }}
                            />
                            <TextInputField
                                value={returnReservationObj.email}
                                fieldLabel={i18n.t('booking.bookingEmail')}
                                onChange={(event) => {
                                    setReturnReservationObj({
                                        ...returnReservationObj,
                                        email: event.currentTarget.value,

                                        justReturned: false,
                                    })
                                }}
                            />
                            <TextInputField
                                value={returnReservationObj.confirm}
                                fieldLabel={i18n.t('booking.bookingComfNumber')}
                                onChange={(event) => {
                                    setReturnReservationObj({
                                        ...returnReservationObj,
                                        confirm: event.currentTarget.value,
                                        justReturned: false,
                                    })
                                }}
                            />
                            <MainButton
                                text={i18n.t('booking.add')}
                                onClick={handleAddRes}
                            />
                        </Box>
                    )}
                </Box>
            </Gutters>
        </NavigationView>
    )
}
